import { BankBookLine, MonitoringLine, CorporateLine } from '@revenuemarket/cds';
import { CUSTOM_ATTRIBUTES } from '@revenuemarket/utils';

import { NavigationItem } from './NavigationMenu';

export const ANALYSIS_NAV_ITEMS: NavigationItem[] = [
  {
    title: '계좌',
    link: '/clobe/cash-status',
    activeKey: 'cash-status',
    icon: <BankBookLine />,
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.ACCOUNTS_ANALYSIS,
  },

  {
    title: '거래처',
    link: '/clobe/sales-purchase',
    activeKey: 'sales-purchase',
    icon: <CorporateLine />,
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.PARTNERS_ANALYSIS,
  },
  {
    title: '손익',
    link: '/clobe/cash-flow',
    activeKey: 'cash-flow',
    icon: <MonitoringLine />,
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.PROFIT_LOSS_ANALYSIS,
  },
];

export const LABELING_NAV_GROUP_ITEMS: NavigationItem[] = [
  {
    title: '은행 거래내역 분류',
    activeKey: 'bank-labeling',
    link: '/clobe/labeling',
  },
  {
    title: '카드 청구내역 분류',
    activeKey: 'card-billing-labeling',
    link: '/clobe/card-billing-labeling',
  },
  // {
  //   title: '카드 이용내역 분류',
  //   activeKey: 'card-transaction-labeling',
  //   link: '/clobe/card-transaction-labeling',
  // },
  {
    title: '분류 계정 관리',
    activeKey: 'label-management',
    link: '/clobe/label-management',
  },
  {
    title: '매출 정산',
    activeKey: 'sales-settlement',
    link: '/clobe/sales-settlement',
  },
  {
    title: '매입 정산',
    activeKey: 'purchase-settlement',
    link: '/clobe/purchase-settlement',
  },
];

export const DATA_NAV_GROUP_ITEMS: NavigationItem[] = [
  {
    title: '은행 거래내역',
    activeKey: 'transactions',
    link: '/clobe/transactions',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.BANK_TRANSACTIONS,
  },
  {
    title: '카드 이용내역',
    activeKey: 'card-approval',
    link: '/clobe/card-approval',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.CARD_APPROVALS,
  },
  {
    title: '카드 매출내역',
    activeKey: 'card-sales',
    link: '/clobe/card-sales',
  },
  {
    title: '세금계산서',
    activeKey: 'tax-invoice-list',
    link: '/clobe/tax-invoice?type=list',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.TAX_INVOICES,
  },
  {
    title: '현금영수증',
    activeKey: 'cash-receipt',
    link: '/clobe/cash-receipt',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.CASH_RECEIPTS,
  },
  {
    title: 'PG/마켓플레이스',
    activeKey: 'pg-marketplace',
    link: '/clobe/pg-marketplace',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.PG_MARKETPLACE,
  },
];

export const FINANCE_GROUP_ITEMS: NavigationItem[] = [
  {
    title: '대출',
    activeKey: 'finance-introduction',
    link: '/clobe/loans',
    customAttributes: CUSTOM_ATTRIBUTES.NAVIGATION_BODY.CLOBE_FINANCE,
  },
  {
    title: '장래매출채권 양도 신청',
    activeKey: 'finance-trade-revenue',
    link: '/dashboard/trade-revenue',
  },
  {
    title: '장래매출채권 양도 내역',
    activeKey: 'finance-trade',
    link: '/dashboard/trade',
  },
];
